import Joi from '@hapi/joi'

export const totalCropReportSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please select valid Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Company").messages({
        "any.invalid": `Please select valid Company`,
        "any.required": `Company required`
    }),
    collectionPointID: Joi.number().label("Collectionpoint").messages({
        "any.invalid": `Please select valid Collectionpoint`,
        "any.required": `Collectionpoint required`
    }),
    month: Joi.string().invalid("").label("Month").required().messages({
        "any.invalid": `Please select Month`,
        "any.required": `Month required`
    }),
}